Service = App.loadClass 'core::Angular/Service'

class exports.QuotesService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getQuotes: () =>
        @http.post 'backend/admin/quotes/get-quotes'

    getSelf: () =>
        @http.post 'backend/admin/funsies/get-self'

    saveContext: (quoteId, context) =>
        @http.post 'backend/admin/quotes/save-quote-context',
            id: quoteId
            context: context

    getQuotablePersons: () =>
        @http.post 'backend/admin/quotes/get-quotable-persons'

    saveQuote: (text, quoteeId) =>
        @http.post 'backend/admin/quotes/save-quote',
            text: text
            quotee: quoteeId
